import { useSyncExternalStore } from "react";

/** Os limites batem com mesa.module.css. */
const COM_TRILHO = "(min-width: 56rem)";
const COM_INSPETOR = "(min-width: 80rem)";

function useMidia(consulta: string): boolean {
  return useSyncExternalStore(
    (avisar) => {
      const m = window.matchMedia(consulta);
      m.addEventListener("change", avisar);
      return () => {
        m.removeEventListener("change", avisar);
      };
    },
    () => window.matchMedia(consulta).matches,
    () => false,
  );
}

/** Notebook e acima: o trilho fica fixo à esquerda; abaixo, vira gaveta. */
export function useLargo(): boolean {
  return useMidia(COM_TRILHO);
}

/** Tela larga: o inspetor fica fixo à direita; abaixo, abre em folha. */
export function useMuitoLargo(): boolean {
  return useMidia(COM_INSPETOR);
}
